import { mapActions, mapGetters } from 'vuex';
import api from "@checkout/services/api";
import router from "@checkout/router";
import { store } from '@checkout/store/store';
import localStorage from "@checkout/services/storage";
import storage from "@checkout/services/storage";
import IntlPhone from "@checkout/components/Partials/IntlPhone.vue";
import { transformErrors } from '@checkout/services/errors';

export default {
    name: 'Login',
    
    components: {
        IntlPhone
    },

    data() {
        return {
            username: '',
            resetUsername: '',
            password: '',
            phoneNumber: '',
            smsCode: '',
            errors: {},
            resetErrors: {},
            userNotFound: '',
            postpaid: true,
            isTv: false,
            skipJumping: false,
            smsLogin: true,
            showRecovery: false,
            appendedClass: ''
        }
    },

    computed: {
        ...mapGetters({
            user: 'user/user',
        }),

        getLocale() {
            return localStorage.get('locale', true) === 'de' ? 'de' : 'sr';
        }
    },

    mounted() {
        this.prepareStep4();
    },

    methods: {
        ...mapActions('user', ['passwordReset', 'attemptToGetSmsCodeViaMsisdn', 'loginViaSms', 'getMe', 'loginViaPassword']),

        prepareStep4() {
            api.get('/public-api/prepare/4/'+ localStorage.get('page-step', true)).then((response) => {
                this.postpaid = response.data.postpaid;
                this.isTv = response.data.tv;
            })
                .catch((error) => {
                this.$swal(this.$i18nApi.t('messages.error'));
                if (error.response.data.hasOwnProperty('page')) {
                    storage.save('page-step', error.response.data.page, true);
                    router.push('/checkout/'+ error.response.data.page)
                } else {
                    router.push('/checkout/1')
                }
            })
        },

        passwordRecovery(data) {
            this.resetErrors = {};

            this.passwordReset(data)
                .then((user) => {
                    this.$swal(user.data.message);
                })
                .catch((error) => {
                    store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');

                    if (error.response.status === 422) {
                        this.resetErrors = transformErrors(error.response.data.errors);
                    } else if (error.response.status === 406) {
                        this.resetErrors = error.response.data.body.error_fields;
                    } else if (error.response.data.hasOwnProperty("error")) {
                        this.$swal(error.response.data.error);
                    } else if (error.response.status === 400) {
                        this.$swal(error.response.data.message);
                    }
                })
        },

        loginViaNumber(authData) {
            this.errors = {};

            this.attemptToGetSmsCodeViaMsisdn(authData)
                .catch((error) => {
                    store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');
                    
                    if (error.response.data.errors && error.response.data.errors.code && error.response.data.errors.code[0] === 'SEND_SMS_TO_USER_FAILED_USER_DOESNT_EXIST') {
                        this.errors = {
                            'phone': {
                                'message': error.response.data.message
                            }
                        };                        
                    } else if (error.response.status === 422) {
                        this.errors = transformErrors(error.response.data.errors);
                    } else if (error.response.status === 406) {
                        this.errors = error.response.data.body.error_fields;
                    } else if (error.response.data.hasOwnProperty("error")) {
                        this.$swal(error.response.data.error);
                    } else if (error.response.status === 400) {
                        console.log(error.response.data.message, error.response.data.message);
                        this.$swal(error.response.data.message);
                    }
                })
        },

        loginWithSms(authData) {
            this.errors = {};

            this.loginViaSms(authData)
                .then((user) => {
                    if (user.contracts[0] && user.contracts[0].contractType === 'Business') {
                        this.$swal({
                            title: this.$i18nApi.t('messages.error'),
                            text: this.$i18nApi.t('businessAccount'),
                            icon: 'warning',
                            buttons: {
                                confirm: {
                                    value: 0
                                }
                            }
                        }).then(() => {
                            router.push('/checkout/5')
                        });
                    }

                    router.push('/checkout/4')
                })
                .catch((error) => {
                    store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');

                    if (error.response.data.errors && error.response.data.errors.code && error.response.data.errors.code[0] === 'SMS_LOGIN_USER_FAILED_INVALID_CODE') {
                        this.errors = {
                            'code': {
                                'message': error.response.data.message
                            }
                        };                        
                    } else if (error.response.status === 422) {
                        this.errors = transformErrors(error.response.data.errors);
                    } else if (error.response.status === 406) {
                        this.errors = error.response.data.body.error_fields;
                    } else if (error.response.data.hasOwnProperty("error")) {
                        this.$swal(error.response.data.error);
                    } else if (error.response.status === 400) {
                        this.$swal(error.response.data.message);
                    }
                })
        },

        loginWithPassword(authData) {
            this.errors = {};

            this.loginViaPassword(authData)
                .then((user) => {
                    this.userNotFound = '';
                    if (user.contracts[0] && user.contracts[0].contractType === 'Business') {
                        this.$swal({
                            title: this.$i18nApi.t('messages.error'),
                            text: this.$i18nApi.t('businessAccount'),
                            icon: 'warning',
                            buttons: {
                                confirm: {
                                    value: 0
                                }
                            }
                        }).then(() => {
                            router.push('/checkout/5')
                        });
                    }

                    router.push('/checkout/4')
                })
                .catch((error) => {
                    store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');

                    if (error.response.data.errors && error.response.data.errors.code && error.response.data.errors.code[0] === 'PIN_LOGIN_USER_FAILED_USER_DOESNT_EXIST_OR_INVALID_DATA') {
                        this.userNotFound = error.response.data.message;                        
                    } else if (error.response.data.errors && error.response.data.errors.code && error.response.data.errors.code[0] === 'REQUEST_FAILED_SERVER_ERROR') {
                        this.userNotFound = error.response.data.message;                        
                    } else if (error.response.status === 422) {
                        this.errors = transformErrors(error.response.data.errors);
                    } else if (error.response.status === 406) {
                        this.errors = error.response.data.body.error_fields;
                    } else if (error.response.data.hasOwnProperty("error")) {
                        this.$swal(error.response.data.error);
                    } else if (error.response.status === 400) {
                        this.$swal(error.response.data.message);
                    }
                })
        },

        submitData() {
            if (this.smsLogin) {
                if (!this.user.isSmsCodeSent) {
                    this.loginViaNumber({ phone: this.phoneNumber });
                } else {
                    this.loginWithSms({ code: this.smsCode, userId: this.user.userId });
                }
            } else {
                this.loginWithPassword({ username: this.username, password: this.password });
            }
        },

        forgotPassword() {
            this.passwordRecovery({ username: this.resetUsername });
        }
    }
}
